<template>

  <v-content>

    <v-overlay :value="overlay">

      <v-progress-circular indeterminate size="64"></v-progress-circular>

    </v-overlay>

    <v-snackbar v-model="errorSnackbar" color="error">

      Please fix the error(s) on the form.

      <template v-slot:action="{ attrs }">

        <v-btn text v-bind="attrs" @click="errorSnackbar = false">

          <v-icon>mdi-close-circle</v-icon>

        </v-btn>

      </template>

    </v-snackbar>

    <v-snackbar v-model="invalidCredentialsSnackbar" color="error">

      You have entered invalid credentials.

      <template v-slot:action="{ attrs }">

        <v-btn text v-bind="attrs" @click="invalidCredentialsSnackbar = false">

          <v-icon>mdi-close-circle</v-icon>

        </v-btn>

      </template>

    </v-snackbar>

    <v-layout align-center justify-center>

      <v-alert icon="mdi-alert-outline">

        <strong>Warning:</strong> The browser’s back button does <u>not</u> work on this system, and if used, any unsaved information will be lost.

      </v-alert>

    </v-layout>

    <v-layout align-center justify-center class="mt-1">

      <v-card elevation="0" class="pb-2" min-width="400px" max-width="400px">

        <v-card-title class="text-h5 word-break"><strong>Sign in</strong></v-card-title>

        <v-card-text>

          <p>Sign in with your email address and password:</p>

          <v-text-field label="Email" v-model="loginInfo.email" type="text" :error-messages="emailErrors" maxlength="100" outlined></v-text-field>

          <v-text-field label="Password" v-model="loginInfo.password" type="password" :error-messages="passwordErrors" maxlength="30" outlined></v-text-field>

        </v-card-text>

        <v-card-actions>

          <v-btn color="primary" class="ml-2" @click="forgotPassword">Forgot password?</v-btn>

          <v-spacer></v-spacer>

          <v-btn color="primary" class="mr-2" @click="login"><v-icon left>mdi-login</v-icon>sign in</v-btn>

        </v-card-actions>

        <v-card-text>

          <hr />

          <v-alert icon="mdi-information-outline">

            <strong>Need an account?</strong><p>Click <a @click="register">here</a> to sign up for an account.</p>

          </v-alert>

        </v-card-text>

      </v-card>

    </v-layout>

  </v-content>

</template>

<script lang="ts">

import Vue from 'vue'

import { required } from "vuelidate/lib/validators";

import axios from "axios";

function validateEmail(value: string | null) {

  return value == null || value == "" || value.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) !== null;

}

export default Vue.extend({

  data: () =>
  {
    return {

      overlay: false,

      loginInfo: {

        email: '',

        password: ''

      },

      errorSnackbar: false,

      invalidCredentialsSnackbar: false

    };
  },

  async created() {

    // implement security (kick users to form, admins to dashboard)

    try {

      let obj = await axios.get('accounts/get-user-info');

      var tokens = obj.data.split('\t');

      var email = tokens[1];

      var role = tokens[2];

      this.$store.dispatch('updateEmail', email);

      this.$store.dispatch('updateRole', role);

      if (role == 'User') {

        if (this.$route.path != '/Form') this.$router.push('/Form');

      }
      else if (role == 'Admin' || role == 'Officer') {

        if (this.$route.path != '/Dashboard') this.$router.push('/Dashboard');

      }
    }
    catch
    {
      // the user is not signed in (do nothing)
    }

  },

  methods:
      {
        clearSnackbars() {

          this.errorSnackbar = false;

          this.invalidCredentialsSnackbar = false;

        },

        forgotPassword()
        {

          this.$router.push('/ForgotPassword');

        },

        register()
        {

          this.$router.push('/Register');

        },

        async login() {

          this.$v.loginInfo.$touch();

          if (!this.$v.loginInfo.$invalid) {

            this.clearSnackbars();

            this.overlay = true;

            setTimeout(async () => {

              let obj = await axios.post('accounts/authenticate', this.loginInfo);

              this.overlay = false

              if (obj.data == '%%INVALID_CREDENTIALS%%')
              {
                this.invalidCredentialsSnackbar = true;
              }
              else
              {
                var tokens = obj.data.split('\t');

                var email = tokens[1];

                var role = tokens[2];

                this.$store.dispatch('updateEmail', email);

                this.$store.dispatch('updateRole', role);

                if (role == 'User') {

                  if (this.$route.path != '/Form') this.$router.push('/Form');

                }
                else if (role == 'Admin' || role == 'Officer') {

                  if (this.$route.path != '/Dashboard') this.$router.push('/Dashboard');

                }

              }

            }, 100);

          } else {

            this.errorSnackbar = true;

          }
        }
      },

  validations:
      {
        loginInfo:
            {
              email: {

                required,

                validateEmail

              },

              password: {

                required

              }
            }
      },

  computed:
      {
        emailErrors()
        {
          if (this.$v.loginInfo.email && !this.$v.loginInfo.email.$dirty) return [];

          if (this.$v.loginInfo.email && !this.$v.loginInfo.email.required) return ['Email is required.'];

          if (this.$v.loginInfo.email && !this.$v.loginInfo.email.validateEmail) return ['Email is invalid.'];

          return null;
        },

        passwordErrors()
        {
          if (this.$v.loginInfo.password && !this.$v.loginInfo.password.$dirty) return [];

          if (this.$v.loginInfo.password && !this.$v.loginInfo.password.required) return ['Password is required.'];

          return null;
        }

      }

})

</script>

<style>

.word-break {

  word-break: break-word;

}

.v-messages__message {

  font-size: 14px !important;

}

th > .v-icon {

  color: white !important;

}

</style>
